import { createContext, FC, ReactNode, useMemo } from 'react';
import { css, styled } from '@robocorp/theme';

export interface ListProps {
  /**
   * @ignore
   */
  id?: string;
  /**
   * @ignore
   */
  className?: string;
  /**
   * List component type
   */
  component?: 'ul' | 'ol' | 'nav';
  /**
   * Divide all list items
   */
  divider?: boolean;
  /**
   * Make all list items dense
   */
  dense?: boolean;
  /**
   * Should all list items have hover state
   */
  hover?: boolean;
  /**
   * @ignore
   */
  children?: ReactNode;
}

export const ListContext = createContext<Partial<ListProps>>({});

const listStyle = css<ListProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: transparent;
`;

const listTypes = {
  ul: styled.ul`
    ${listStyle}
  `,

  nav: styled.nav`
    ${listStyle}
  `,

  ol: styled.ol`
    ${listStyle}
  `,
};

/**
 * List component
 */
const List: FC<ListProps> = ({ component, children, divider, dense, hover, ...rest }) => {
  const ListStyled = listTypes[component || 'ul'];

  const contextValue = useMemo(() => ({ divider, dense, hover }), [divider, dense, hover]);

  return (
    <ListStyled {...rest}>
      <ListContext.Provider value={contextValue}>{children}</ListContext.Provider>
    </ListStyled>
  );
};

List.defaultProps = {
  component: 'ul',
  hover: true,
};

export default List;
